import {ParentView} from "../parentView";
import {EventTypes} from "../../helpers/eventtypes";


class ContactUsView extends ParentView {  
    constructor(formId: string, btnSaveId: string) {
        super(formId, btnSaveId);  
        
    }
    InitView(): void {
        //Add Button Click Event 
        this.AddSaveButtonClickForValidation();
    }

    
}
export { ContactUsView }
/* add Listener */
document.addEventListener(EventTypes.DOMContentLoaded, () => {
    let obj: ContactUsView = new ContactUsView("ContactUs-form", "gposubmit_btn");  
    obj.InitView();
});
